import { createApiFetcher, createApiUpdater, createApiPoster, createApiDeleter, uploadFile } from 'src/utils/ApiUtils';
import { I94BannerStatus, IDeviceRegistration, UserContact } from 'src/shared/types/User';
import { ImsAxiosInstance } from '../axios/axios';

const Profile = 'profile/';

const fetchData = createApiFetcher(Profile);
const updateData = createApiUpdater(Profile);
const postData = createApiPoster(Profile);
const deleteData = createApiDeleter(Profile);

export const getUserContacts = (userId: number, isPrincipal = true): Promise<UserContact> => {
  const apiParam = isPrincipal ? 'userId' : 'dependentId';
  return fetchData<UserContact>('user-contacts', { [apiParam]: userId });
};

export const getUserProfilesImage = (userId: number): Promise<string> =>
  fetchData<string>(`user-profiles-image/${userId}`);

/**
 * TODO: We created an endpoint in fn-api to upload the profile image('profile/user-profiles-image'), but it's not working.
 *       There is an existing issue with calling the IMS API from fn-api for image uploads. So, for now, we have decided to use the IMS API directly for profile image uploads.
 *       We will revisit this in the future to determine whether we can use fn-api for this.
 */
export const uploadUserProfileImage = (formData: FormData): Promise<void> =>
  uploadFile<void>('api/ProfilesImage', formData, ImsAxiosInstance);

export const addContactPhoneDetails = (data: Record<string, unknown>): Promise<Record<string, unknown>> =>
  postData('contact-phone', data);

export const updateContactPhoneDetails = (data: Record<string, unknown>): Promise<Record<string, unknown>> =>
  updateData('contact-phone', data);

export const deleteContactPhone = (id: number): Promise<void> => deleteData<void>(`contact-phone/${id}`);

export const addContactEmail = (data: Record<string, unknown>): Promise<Record<string, unknown>> =>
  postData('contact-email', data);

export const updateContactEmail = (data: Record<string, unknown>): Promise<Record<string, unknown>> =>
  updateData('contact-email', data);

export const deleteContactEmail = (id: number): Promise<void> => deleteData<void>(`contact-email/${id}`);

export const addContactAddress = (data: Record<string, unknown>): Promise<Record<string, unknown>> =>
  postData('contact-address', data);

export const updateContactAddress = (data: Record<string, unknown>): Promise<Record<string, unknown>> =>
  updateData('contact-address', data);

export const deleteContactAddress = (id: number): Promise<void> => deleteData<void>(`contact-address/${id}`);

const User = 'user/';

const fetchUserData = createApiFetcher(User);
const updateUserData = createApiUpdater(User);

export const saveUserPreferences = async (preferences: any): Promise<void> =>
  await updateUserData('settings', preferences);

export const getUserDeviceRegistrationDate = async (userId: number): Promise<IDeviceRegistration> =>
  await fetchUserData(`mfa-registration?userId=${userId}`);

export const saveMFASettings = async (mfaSettings: any): Promise<void> =>
  await updateUserData('mfa-settings', mfaSettings);

export const removeMFARegisteredDevice = async (): Promise<void> => updateUserData('mfa-device');

export const getI94BannerStatus = async (): Promise<I94BannerStatus> =>
  await fetchUserData<I94BannerStatus>('i94-banner-status');

export const saveI94BannerDismissedDate = async (dismissedDate: string): Promise<void> => {
  await updateUserData('i94-banner-dismissed-date', { dismissedDate });
};
